import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { GlobalService } from '../global.service';

@Component({
  selector: 'app-counter-wise-agent-delivery-per-date',
  templateUrl: './counter-wise-agent-delivery-per-date.component.html',
  styleUrls: ['./counter-wise-agent-delivery-per-date.component.scss']
})

export class CounterWiseAgentDeliveryPerDateComponent implements OnInit {
  counter_list: any = [];
  selected_counter_id: any;
  selected_date: any ;
  selected_report_option: any;
  counte_agent_order_details: any = null;
  grand_total_colspan: any = null;
  counter_customer_order_details: any;
  is_data_available = true;
  is_document_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  booth_code_list: string[];
  title: string;
  tomorrow: any = null;

  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
    // this.title = 'Daily Counter Sale - Report';
    console.log(this.global._active_display_name);
    this.httpService.serveCounterList().subscribe((data) => {
      console.log(data);
      this.counter_list = data['final_list'];
    }, (error) => {
      console.error(error);
    });
  }

  printCalled() {
    var divToPrint=document.getElementById("printTable");
    let newWin= window.open("");
    newWin.document.write(divToPrint.outerHTML);
    newWin.print();
    newWin.close();
  }

  getClicked() {
    let data_dict = {
      'selected_counter_id': this.selected_counter_id,
      'selected_date': this.selected_date,
      // 'selected_report_option': this.selected_report_option
    };
    console.log(data_dict);
    this.is_data_available = false;
    this.httpService.serveCounterReportJsonForAgentDelivery(data_dict).subscribe((data) => {
      console.log(data);
      this.is_data_available = true;
      this.counte_agent_order_details = data;
      this.booth_code_list = data['booth_list'];
      this.grand_total_colspan = this.counte_agent_order_details['product_list'].length + 3;
      console.log(this.grand_total_colspan);
      // setTimeout(() => {
      //   document.getElementById('grand_total').setAttribute("colspan", this.grand_total_colspan);
      // }, 1000);
      console.log(this.counte_agent_order_details);
    }, (error) => {
      this.is_data_available = true;
      console.error(error);
    });

  }

  downloadReportCliked() {
    let data_dict = {
      'selected_counter_id': this.selected_counter_id,
      'selected_date': this.selected_date,
      'selected_report_option': 'booth'
    };
    this.is_document_available = false;
    this.httpService.serveCounterReportForAgentDelivery(data_dict).subscribe((data) => {
      const linkSource = 'data:application/pdf;base64,' + data['pdf'];
      const downloadLink = document.createElement("a");
      const fileName = data['file_name'];
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
      console.error(error);
    });
  }

  checkDisable() {
    if (this.selected_counter_id == null || this.selected_date == null) {
      return true;
    } else {
      return false;
    }
  }

  changeEvent() {
    let date_in_format = new Date(this.selected_date);
    date_in_format.setDate(date_in_format.getDate() + 1);
    this.tomorrow= new Date(date_in_format).toISOString().split('T')[0];
    this.is_document_available = true;
  }

  ngOnInit() {
  }


}
